export type MappingTarget = 'clienti' | 'prodotti' | 'prezzi' | 'offerte';

export const MAPPING_TARGET_CONFIG: Record<
  MappingTarget,
  { label: string; defaultQueryId: string; defaultName: string; keyFields: string[]; fields: string[] }
> = {
  clienti: {
    label: 'Clienti',
    defaultQueryId: 'clienti_as400',
    defaultName: 'Import Clienti AS400',
    keyFields: ['partita_iva', 'codice_fiscale', 'email'],
    fields: ['tipo', 'ragione_sociale', 'nome', 'cognome', 'partita_iva', 'codice_fiscale', 'email', 'telefono', 'indirizzo', 'citta', 'provincia', 'cap', 'pec', 'codice_erp', 'codice_destinatario', 'note', 'referente_interno', 'canale_riferimento'],
  },
  prodotti: {
    label: 'Prodotti',
    defaultQueryId: 'prodotti_as400',
    defaultName: 'Import Prodotti AS400',
    keyFields: ['codice'],
    fields: ['codice', 'codice_metel', 'nome', 'descrizione', 'categoria', 'marca', 'unita_misura', 'prezzo_unitario', 'prezzo_acquisto', 'aliquota_iva', 'is_attivo', 'is_servizio'],
  },
  prezzi: {
    label: 'Prezzi/Listino',
    defaultQueryId: 'prezzi_as400',
    defaultName: 'Import Prezzi AS400',
    keyFields: ['prodotto_codice'],
    fields: ['prodotto_codice', 'prezzo_unitario', 'prezzo_minimo', 'listino_codice', 'listino_nome'],
  },
  offerte: {
    label: 'Offerte',
    defaultQueryId: 'offerte_as400',
    defaultName: 'Import Offerte AS400',
    keyFields: ['numero'],
    fields: [
      'numero',
      'anno',
      'titolo',
      'descrizione',
      'stato',
      'importo_totale',
      'importo_imponibile',
      'importo_iva',
      'cliente_partita_iva',
      'cliente_codice_fiscale',
      'cliente_email',
      'cliente_ragione_sociale',
      'cliente_nome',
    ],
  },
};

